import axios from "axios";
import { redirectUrl } from "config";
import { baseUrl } from "config";
import { useSnackBar } from "context/snackbarContext";
import React from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

function Print() {
  const location = useLocation();
  const {
    data,
    tableData,
    qrData,
    printType,
    typ,
    isInvoiceData,
    invoiceOnly,
    kotTableData,
    navigateBackThermalDirect = -1,
    navigateBack = -2,

  } = location.state;


  const navigate = useNavigate();
  const { showSnackbar } = useSnackBar();


  useEffect(() => {
    const renderComponent = () => {
      switch (printType) {
        case "LazerA4PrintB2b_TAXGST":
          if (
            typ === "SB" ||
            typ === "SR" ||
            typ === "SRB2C" ||
            typ === "OF" ||
            typ === "B2C"
          ) {
            return navigate("/printer/a4", { 
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack,
              },
            });
          } else {
            return navigate("/printer/purchaseA4", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
              },
            });
          }
        case "LazerA4PrintB2b_TAXGST_two":
          if (
            typ === "SB" ||
            typ === "SR" ||
            typ === "SRB2C" ||
            typ === "OF" ||
            typ === "B2C"
          ) {
            return navigate("/printer/a4Two", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
                navigateBack: navigateBack,
              },
            });
          } else {
            return navigate("/printer/purchaseA4", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
              },
            });
          }

        case "ThermalPrintB2b_TAXGST":
          if (
            typ === "SB" ||
            typ === "SR" ||
            typ === "SRB2C" ||
            typ === "B2C"
          ) {
            return navigate("/printer/thermalPrint", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
              },
            });
          } else {

            return navigate("/printer/purchaseThermal", {
              state: {
                data: data,
                tableData: tableData,
                qrData: qrData,
                typ: typ,
              },
            });
          }
        case "LazerA4PrintB2b_TAXVAT":
          return navigate("/printer/lazerA4PrintTaxVat", {
            state: {
              data: data,
              tableData: tableData,
              qrData: qrData,
              typ: typ,
            },
          });
        case "ThermalPrintB2b_TAXVAT":
          return navigate("/printer/ThermalPrintTaxVat", {
            state: {
              data: data,
              tableData: tableData,
              qrData: qrData,
              typ: typ,
            },
          });
        case "ThermalPrint4Inch_TAXVAT":
          return navigate("/printer/thermalPrint4Inch", {
            state: {
              data: data,
              tableData: tableData,
              qrData: qrData,
              typ: typ,
            },
          });
        case "THERMAL_3INCH_DIRECT":
       

          // navigate(-1);
          navigate(navigateBackThermalDirect);
          return axios({
            method: "post",
            url: baseUrl + "/print",
            data: {
              master: data,
              table: tableData,
              typ: "THERMAL_3INCH_DIRECT",
              isInvoiceData,
              invoiceOnly,
              qrData: qrData,
              kotTableData,
            },
            withCredentials: true,
          })
            .then((res) => {})
            .catch((err) => {
              showSnackbar("error", err?.response?.data?.message);

              if (err.response.status === 403 || err.response.status === 401) {
                redirectUrl();
              }
            });
        case "THERMAL_3INCH_DIRECT_VAT":


          navigate(-1);
          return axios({
            method: "post",
            url: baseUrl + "/print",
            data: {
              master: data,
              table: tableData,
              typ: "THERMAL_3INCH_DIRECT_VAT",
              isInvoiceData,
              invoiceOnly,
              qrData: qrData,
              kotTableData,
            },
            withCredentials: true,
          })
            .then((res) => {})
            .catch((err) => {
              showSnackbar("error", err?.response?.data?.message);

              if (err.response.status === 403 || err.response.status === 401) {
                redirectUrl();
              }
            });
        default: {
          // navigate(-1);
          navigate(navigateBackThermalDirect);
          return showSnackbar("error", `Please select printer`);
        }
      }
    };
    renderComponent();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, navigate, printType, qrData, tableData, typ]);

  return <div> </div>;
}

export default Print;
